import { joinWithCommas } from './utils';
export default function post(hit, overline) {
  const { title, url, excerpt, media, authors } = hit;
  const author = authors[0] || {};

  const postThumbnail = media
    ? `<div class="tease__art"><a href="${url}"><img class="tease__img" src="${media}" alt="${title}" /></a></div>`
    : '';
  const authorName = author.name ? `<span class="tease__author__name">${author.name}</span>` : '';
  const authorTitle = author.title
    ? `<span class="tease__author__description">${author.title}</span>`
    : '';
  const authorHeadshot = author.headshot
    ? `<div class="tease__author__headshot" style="background-image: url(${author.headshot})"></div>`
    : '';
  const authorLink = author.link
    ? `<a href="${author.link}/" class="tease__author__link">${authorHeadshot}<div class="tease__author__text">${authorName}${authorTitle}</div></a>`
    : `<div class="tease__author__link">${authorHeadshot}<div class="tease__author__text">${authorName}${authorTitle}</div></div>`;

  return `
    <div class="tease tease--search">
      ${overline ? `<span class="tease__overline">${joinWithCommas(hit[overline])}</span>` : ''}
      <div class='tease__inner'>
      ${postThumbnail}
      <div class="tease__text-mod">
        <a class="tease__hgroup" href="${url}">
          <h3 class="tease__h">
            <span class="tease__h-underline">${title}</span>
          </h3>
          <p class="tease__desc">${excerpt}</p>
        </a>
        <div class="tease__author">${authorLink}</div>
      </div>
    </div>
  `;
}
